<template>
	<div class="bottom-nav" :active.sync="activeBtn" :value="showNav">
		<div class="bottom-nav-item-left" @click="goTo()">
			<router-link class="bottom-nav-links" to>
				<v-btn class="bottom-nav-item">
					<v-icon>chevron_left</v-icon>
				</v-btn>
			</router-link>
		</div>

		<div v-if="checkOption('searchTurisem')" class="bottom-nav-item-middle">
			<div @click="open_modal_search" class="bottom-nav-links">
				<v-btn class="bottom-nav-item">
					<v-icon>search</v-icon>
				</v-btn>
			</div>
		</div>

		<div v-if="checkOption('makeRaport')" class="bottom-nav-item-middle">
			<router-link class="bottom-nav-links" to="/report/makereport">
				<v-btn class="bottom-nav-item">
					<v-icon>note_add</v-icon>
				</v-btn>
			</router-link>
		</div>

		<div class="bottom-nav-item-right">
			<router-link class="bottom-nav-links" to="/">
				<v-btn class="bottom-nav-item">
					<v-icon>home</v-icon>
				</v-btn>
			</router-link>
		</div>
	</div>
</template>

<script>
export default {
  name: "FooterTabsNavigation",
	props: {
		/* makeRaport: {
			type: [Boolean],
			default: false
		}, */
		/* searchTurisem: {
			type: [Boolean],
			default: false
		}, */
		go_to: {
			type: [String],
			default: "/"
		}
	},
	data() {
		return {
			activeBtn: -1,
			showNav: true
		};
	},
	computed: {
		makeRaport(){
			let makeRaport = false
			const matchedRoutes = this.$route.matched
			const route = matchedRoutes[matchedRoutes.length -1]
			if (
				(this.$route.matched[0].props.default && this.$route.matched[0].props.default.makeRaport)
				&& (!route.props || !route.props.default || route.props.default.makeRaport != false)
			) {
				makeRaport = true
			}
			return makeRaport
		},
		searchTurisem(){
			let searchTurisem = false
			if (this.$route.matched[0].props.default && this.$route.matched[0].props.default.searchTurisem) {
				searchTurisem = true
			}
			return searchTurisem
		}
	},
	methods: {
		goTo() {
			if (this.go_to != "/") {
				this.$emit("renderComponent", "/");
			}
			this.$router.go(-1);
		},
		open_modal_search() {
			//this.$store.commit("setOtherDialogActivity", true);
			this.$router.push({name: 'turisem_search'})
		},
		checkOption(option){
			let enable = false
			const matchedRoutes = this.$route.matched
			const route = matchedRoutes[matchedRoutes.length -1]
			if (
				(this.$route.matched[0].props.default && this.$route.matched[0].props.default[option])
				&& (!route.props || !route.props.default || route.props.default[option] != false)
			) {
				enable = true
			}
			return enable

		}
	}
};
</script>

<style lang="scss" scoped>
.bottom-nav {
	background-color: pink !important;
	z-index: 4;
	display: flex;
	justify-content: center;
	.bottom-nav-item-left {
		position: fixed;
		bottom: 16px;
		left: 16px;
		z-index: 4;
	}
	.bottom-nav-item-middle {
		position: fixed;
		bottom: 16px;
		margin: 0 auto;
		z-index: 4;
	}
	.bottom-nav-item-right {
		position: fixed;
		bottom: 16px;
		right: 16px;
		z-index: 4;
	}
	.bottom-nav-item {
		background-color: white !important;
		box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05);
		border-radius: 10px;
		width: 50px;
		height: 50px;
		padding: 0 !important;
		margin: 0 !important;
		.v-btn__content {
			min-width: auto !important;
		}
	}
	.bottom-nav-links {
		color: transparent !important;
	}
	.v-icon {
		font-size: 30px;
	}
	.v-btn {
		min-width: auto !important;
	}
}
</style> 